import { tkParse } from '@moke/vue-tk'
export default {
  // 更新用户信息
  async updateUserMsg ({ state, commit }, options) {
    await tkParse
      .put(`/classes/_User/${state.user.objectId}`, options)
      .catch((e) => {
        throw e
      })
    let data = await tkParse.getData(`/classes/_User/${state.user.objectId}`)
    data.sessionToken = state.sessionToken
    commit('setUser', data)
  },
  // 获取我的课程列表
  async fetchMyCourses ({ state, commit }) {
    if (!state.user || !state.sessionToken) {
      commit('setMyCourseIds', [])
      return
    }
    try {
      const result = await tkParse.getList('/classes/exchangeRecord', {
        params: {
          limit: 1000,
          keys: 'course',
          where: {
            exchangeUser: state.user.objectId,
            status: '已使用'
          }
        }
      })
      const courseIds = result
        .filter((record) => record.course)
        .map((record) => record.course)
      commit('setMyCourseIds', courseIds)
    } catch (e) {
      console.error('获取我的课程列表失败', e)
      commit('setMyCourseIds', [])
    }
  }
}
